import apiClient from './axios';

export type ProductRequestStatus =
  | 'pending'
  | 'sourcing'
  | 'found'
  | 'unavailable'
  | 'fulfilled'
  | 'cancelled';

export interface ProductRequest {
  id: string;
  userId: string;
  imageUrls: string[];
  note: string | null;
  status: ProductRequestStatus;
  adminNote: string | null;
  matchedProductId: string | null;
  createdAt: string;
  updatedAt: string;
}

export const productRequestsApi = {
  async list(params: {
    page?: number;
    limit?: number;
    status?: ProductRequestStatus;
  }): Promise<{
    items: ProductRequest[];
    meta: { total: number; page: number; limit: number; totalPages: number };
  }> {
    const res = await apiClient.get('/admin/product-requests', { params });
    return res.data.data;
  },

  async update(
    id: string,
    payload: {
      status: ProductRequestStatus;
      adminNote?: string;
      matchedProductId?: string;
    },
  ): Promise<ProductRequest> {
    const res = await apiClient.patch(`/admin/product-requests/${id}`, payload);
    return res.data.data;
  },
};
